import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { Messages } from '../../codegen/Localize';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { IDataSourceDetailInfo } from '../../ts/models/IDataSourceInfo';
import { ContentActions } from '../../ts/services/ContentActions';
import { ServerService } from '../../ts/services/ServerService';
import { requestFailed } from '../../app/actions/RequestFailedAction';
import { NewMetricForDatasourceAction } from '../actions/NewMetricForDatasourceAction';
import { ServiceLocator } from '../../app/ServiceLocator';
import { getDatasourceDetailInfo, openBlankWindow, replaceDatasourceIdWithConnectionIdForMixedContent } from '../../app/sagas/spaces/SpacesSagaHelpers';

// When a new window is created, if it's not part of a click event handler it will be detected by browsers as a pop-up.
// Because we are opening a new window in the edit workbook saga which is async, to get around the pop up blocker we need
// to open the window first, then the window.location.href can be set asynchronously afterwards

export function* handleNewMetricForDatasourceAction(action: NewMetricForDatasourceAction): SagaIterator {
  if (!FeatureFlags.metricsAuthoringPathEnabled) {
    return;
  }
  let newWindow: Window = null;
  try {
    newWindow = openBlankWindow();
    const mutableContentInfo: IContentInfo[] = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, [action.contentInfo]);
    const datasourceDetailInfo = yield call(getDatasourceDetailInfo, mutableContentInfo[0].id);
    createNewMetricForDatasource(datasourceDetailInfo, newWindow);
  } catch(e) {
    newWindow && newWindow.close();
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function createNewMetricForDatasource(datasourceDetailInfo: IDataSourceDetailInfo, newWindow: Window) {
  const contentActionsService = ServiceLocator.get<ContentActions>('ContentActions');
  const serverService = ServiceLocator.get<ServerService>('ServerService');
  newWindow.location.href = contentActionsService.generateNewMetricForDatasourceUrl(datasourceDetailInfo, serverService.sessionSiteUrlName());
}
